import DynamicCotrol from './src/dynamiccotrol.vue';

DynamicCotrol.install = function (Vue) {
    Vue.component(DynamicCotrol.name, DynamicCotrol);
};

export default DynamicCotrol;